export default "__VITE_ASSET__Chu6ShID__"